<script>
	export let buttonText = '';
	export let isOpen = false;
</script>

<div class="wrapper" class:isOpen>
	<button on:click={() => (isOpen = !isOpen)}
		>{buttonText}
		<span class:isOpen
			><svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M1 1L7 7L13 1" stroke="#727178" stroke-linecap="round" stroke-linejoin="round" />
			</svg>
		</span></button
	>
	{#if isOpen}
		<div class="inner-wrapper">
			<slot />
		</div>
	{/if}
</div>

<style>
	.wrapper {
		padding: 15px 10px;
		border: 1px solid #dedee0;
		border-radius: 6px;
		margin-bottom: 1em;
	}

	.wrapper:hover {
		background-color: #f5f5f7;
	}
	div.isOpen:hover {
		background-color: #fff;
	}
	button {
		width: 100%;
		padding: unset !important;
		font-size: 1.1rem;
		color: var(--l-c);
		font-weight: 700;
		text-align: left;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.inner-wrapper {
		margin-top: 20px;
	}
	button span {
		transition: transform 0.2s;
	}
	span.isOpen {
		transform: rotateX(0.5turn);
	}
</style>
